// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
  min-width: 700px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

.content {
  padding: 14px;
  border-radius: 4px;
}

.create-company-section {
  padding: 12px 14px;
  border: 1px solid #c8d8e5;
  border-left: 4px solid #0066b2;
  border-radius: 4px;
  background-color: #f5f9fc;
}

.create-company-section h3 {
  margin: 0 0 2px;
  color: #1f2933;
  font-size: 18px;
  font-weight: 700;
}

.create-company-section p {
  margin: 0 0 10px;
  color: #5f6b76;
  font-size: 14px;
}

.add-company-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.add-company-row label {
  min-width: 105px;
}

.add-company-row .form-control {
  flex: 1;
}

.form-control {
  max-width: 460px;
}

.companies-grid-container {
  max-height: 450px;
  overflow: auto;
  border: 1px solid #dbdcdd;
}

.companies-grid {
  width: 100%;
  border-collapse: collapse;
}

.table-header {
  background-color: #0066b2;
  color: #fff;
  position: sticky;
  top: 0;
}

th, td {
  padding: 8px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
}

.actions {
  width: 320px;
  white-space: nowrap;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.company-group-row td {
  padding: 7px 10px;
  border-bottom: 1px solid #c8d8e5;
  background-color: #dfeaf3;
  color: #34495e;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.status-badge {
  display: inline-block;
  min-width: 68px;
  padding: 3px 8px;
  border-radius: 12px;
  background-color: #d9f0df;
  color: #236b35;
  text-align: center;
  font-size: 13px;
  font-weight: 700;
}

.status-badge--inactive {
  background-color: #e5e7eb;
  color: #59636e;
}

.danger-button {
  background-color: #b42318 !important;
  border-color: #b42318 !important;
}

.inactive {
  color: #6c757d;
  background-color: #f4f4f4;
}

.empty, .loading {
  padding: 30px;
  text-align: center;
}

.loading {
  display: flex;
  justify-content: center;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.btn::after {
  content: '' !important;
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/tools/manage-service-companies/manage-service-companies.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B","sourcesContent":["mat-dialog-content {\n  min-width: 700px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\n.content {\n  padding: 14px;\n  border-radius: 4px;\n}\n\n.create-company-section {\n  padding: 12px 14px;\n  border: 1px solid #c8d8e5;\n  border-left: 4px solid #0066b2;\n  border-radius: 4px;\n  background-color: #f5f9fc;\n}\n\n.create-company-section h3 {\n  margin: 0 0 2px;\n  color: #1f2933;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.create-company-section p {\n  margin: 0 0 10px;\n  color: #5f6b76;\n  font-size: 14px;\n}\n\n.add-company-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.add-company-row label {\n  min-width: 105px;\n}\n\n.add-company-row .form-control {\n  flex: 1;\n}\n\n.form-control {\n  max-width: 460px;\n}\n\n.companies-grid-container {\n  max-height: 450px;\n  overflow: auto;\n  border: 1px solid #dbdcdd;\n}\n\n.companies-grid {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table-header {\n  background-color: #0066b2;\n  color: #fff;\n  position: sticky;\n  top: 0;\n}\n\nth, td {\n  padding: 8px;\n  border-bottom: 1px solid #e0e0e0;\n  text-align: left;\n}\n\n.actions {\n  width: 320px;\n  white-space: nowrap;\n}\n\n.action-buttons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.company-group-row td {\n  padding: 7px 10px;\n  border-bottom: 1px solid #c8d8e5;\n  background-color: #dfeaf3;\n  color: #34495e;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.status-badge {\n  display: inline-block;\n  min-width: 68px;\n  padding: 3px 8px;\n  border-radius: 12px;\n  background-color: #d9f0df;\n  color: #236b35;\n  text-align: center;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.status-badge--inactive {\n  background-color: #e5e7eb;\n  color: #59636e;\n}\n\n.danger-button {\n  background-color: #b42318 !important;\n  border-color: #b42318 !important;\n}\n\n.inactive {\n  color: #6c757d;\n  background-color: #f4f4f4;\n}\n\n.empty, .loading {\n  padding: 30px;\n  text-align: center;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.btn::after {\n  content: '' !important;\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
